/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Lot_Items_RowInputs */

const vi_lot_items_row = /** @type {(inputs: Lot_Items_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lô #${i?.n}`)
};

/**

* @param {Lot_Items_RowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_row = /** @type {((inputs: Lot_Items_RowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_RowInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_row(inputs)
});